export function PendingModal({ onClose }: { onClose: () => void }) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.45)",
        zIndex: 500,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "12px",
          padding: "24px",
          maxWidth: "360px",
          width: "90%",
          boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            fontSize: "16px",
            fontWeight: 700,
            color: "#202223",
            marginBottom: "10px",
          }}
        >
          Compra en proceso
        </div>
        <div
          style={{
            fontSize: "14px",
            color: "#6d7175",
            lineHeight: 1.5,
            marginBottom: "20px",
          }}
        >
          Detectamos un pago para este paquete que aún no se ha terminado de
          procesar.
          <br />
          <br />
          Si cerraste la ventana de pago o decidiste no completarlo, el sistema
          cancelará la solicitud automáticamente en unos{" "}
          <strong>30 minutos</strong> y podrás volver a intentarlo.
        </div>
        <button
          onClick={onClose}
          style={{
            background: "#008060",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "8px 16px",
            fontSize: "14px",
            fontWeight: 600,
            cursor: "pointer",
            width: "100%",
          }}
        >
          Entendido
        </button>
      </div>
    </div>
  );
}
